module.exports = __webpack_public_path__ + "img/logo-start.1382b318.png";